export const SteadyGrowthIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="59.904"
    height="58.248"
    viewBox="0 0 59.904 58.248"
  >
    <g id="Icon" transform="translate(-1.25 -1.549)">
      <path
        id="Path_87"
        data-name="Path 87"
        d="M3.189,29.295a2.091,2.091,0,0,0,2.09,2.09H49.856a2.091,2.091,0,0,0,2.09-2.09c0-2.767-1.845-5.478-5.322-7.554-4.3-2.566-11.23-4.289-19.055-4.289S12.814,19.174,8.511,21.741C5.036,23.817,3.189,26.528,3.189,29.295Z"
        transform="translate(3.464 28.412)"
        fill="#0097fa"
        fillRule="evenodd"
      />
      <path
        id="Path_88"
        data-name="Path 88"
        d="M15.343,41.5a65.711,65.711,0,0,1,5.244-16.692c2.55-5.286,6.2-10.533,11.489-13.178A2.089,2.089,0,1,0,30.21,7.895c-6.1,3.051-10.444,9-13.387,15.1a70.288,70.288,0,0,0-5.612,17.89,2.089,2.089,0,1,0,4.132.619Z"
        transform="translate(17.754 10.943)"
        fill="#0097fa"
        fillRule="evenodd"
      />
      <path
        id="Path_89"
        data-name="Path 89"
        d="M13.595,25.858l2.316,5.133A64.53,64.53,0,0,1,32.39,16.058,4.878,4.878,0,0,1,30.211,22.6c-4.066,2.031-6.991,5.829-9.185,9.859a16.858,16.858,0,0,0,8.6.359c5.6-1.421,8.5-6.367,9.764-11.957,1.705-7.563.437-16.151.437-16.151A2.093,2.093,0,0,0,37.52,2.944C23.643,4.58,17.384,9.256,14.726,13.979a15.7,15.7,0,0,0-1.131,11.879Z"
        transform="translate(20.868 2.467)"
        fill="#0097fa"
        fillRule="evenodd"
      />
      <path
        id="Path_90"
        data-name="Path 90"
        d="M25.8,45.119a52.7,52.7,0,0,0-.7-15.5C23.413,21.037,19,11.17,8.363,5.851a2.09,2.09,0,1,0-1.87,3.74C15.787,14.235,19.526,22.932,21,30.422a48.507,48.507,0,0,1,.655,14.145,2.09,2.09,0,0,0,4.144.552Z"
        transform="translate(7.301 7.291)"
        fill="#0097fa"
        fillRule="evenodd"
      />
      <path
        id="Path_91"
        data-name="Path 91"
        d="M22.433,29.125a22.4,22.4,0,0,0-9.884-9.753,4.879,4.879,0,0,1-2.182-6.543C10.783,12,25.632,25.1,28.419,27.885l1.354-5.531c.6-3.166.842-8.321-2.444-12.737C24.1,5.267,17.3,1.418,3.323,1.552A2.09,2.09,0,0,0,1.252,3.6S1.08,12.275,3.727,19.562c1.956,5.386,5.462,9.926,11.2,10.628a16.159,16.159,0,0,0,7.51-1.064Z"
        transform="translate(0 0)"
        fill="#0097fa"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

export const TargetIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="59.904"
    height="59.904"
    viewBox="0 0 59.904 59.904"
  >
    <g id="target" transform="translate(0 -0.001)">
      <g id="Group_302" data-name="Group 302" transform="translate(0 0.001)">
        <g id="Group_301" data-name="Group 301" transform="translate(0 0)">
          <path
            id="Path_84"
            data-name="Path 84"
            d="M31.216,28.746c-.01-.01-.013-.024-.023-.034L21.177,18.7V12.4a1.754,1.754,0,0,0-.514-1.241L10.133.515a1.755,1.755,0,0,0-3,1.241V7.021H1.755a1.755,1.755,0,0,0-1.241,3L11.162,20.664a1.754,1.754,0,0,0,1.241.514H18.7L28.712,31.194c.01.01.024.013.034.023a1.747,1.747,0,0,0,2.47-2.47Z"
            transform="translate(0 -0.001)"
            fill="#0097fa"
          />
        </g>
      </g>
      <g
        id="Group_304"
        data-name="Group 304"
        transform="translate(0.001 0.002)"
      >
        <g id="Group_303" data-name="Group 303" transform="translate(0)">
          <path
            id="Path_85"
            data-name="Path 85"
            d="M29.955,0A29.689,29.689,0,0,0,17.4,2.929l5.384,5.384A22.872,22.872,0,1,1,8.314,22.778L2.93,17.394A29.693,29.693,0,0,0,0,29.954,29.952,29.952,0,1,0,29.955,0Z"
            transform="translate(-0.003 -0.002)"
            fill="#0097fa"
          />
        </g>
      </g>
      <g
        id="Group_306"
        data-name="Group 306"
        transform="translate(14.157 14.158)"
      >
        <g id="Group_305" data-name="Group 305">
          <path
            id="Path_86"
            data-name="Path 86"
            d="M136.8,121a15.61,15.61,0,0,0-5.265.97v2.115l4.057,4.057a8.639,8.639,0,0,1,1.208-.122,8.775,8.775,0,1,1-8.775,8.775,8.636,8.636,0,0,1,.122-1.208l-4.057-4.057h-2.115A15.61,15.61,0,0,0,121,136.8,15.795,15.795,0,1,0,136.8,121Z"
            transform="translate(-121.002 -121.001)"
            fill="#0097fa"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const AssistantIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72.631"
    height="60"
    viewBox="0 0 72.631 60"
  >
    <path
      id="customer-service"
      d="M80.6,83.866a10.462,10.462,0,0,1-9.991,10.889q-.243.011-.485.011a10.26,10.26,0,0,1-2.187-.237A28.176,28.176,0,0,1,48.888,107.01a6.091,6.091,0,1,1-.194-4.424,23.73,23.73,0,1,0-25.1-11.763,1.44,1.44,0,0,1,.147.369,2.191,2.191,0,0,1-1.218,2.764,10.344,10.344,0,0,1-4.014.81q-.243,0-.488-.011A10.46,10.46,0,0,1,8.035,83.865c.047-1.1.021-2.088,0-3.04-.024-.9-.048-1.823-.008-2.79a10.47,10.47,0,0,1,10.511-10,28.118,28.118,0,0,1,51.565,0,10.462,10.462,0,0,1,10.511,10c.041.969.016,1.9-.008,2.792C80.577,81.777,80.551,82.762,80.6,83.866ZM62.738,79.261A18.429,18.429,0,0,1,39.584,97.067l-7.457,4.306a2.2,2.2,0,0,1-3.22-2.471l1.906-7.109A18.424,18.424,0,1,1,62.738,79.261Zm-23.544,0a2.2,2.2,0,0,0-2.2-2.2h0a2.2,2.2,0,1,0,2.2,2.2Zm7.318,0a2.08,2.08,0,0,0-.012-.215,2.049,2.049,0,0,0-.032-.214,1.662,1.662,0,0,0-.053-.208c-.02-.069-.045-.136-.072-.2a1.8,1.8,0,0,0-.092-.193,2.113,2.113,0,0,0-.11-.185,2.148,2.148,0,0,0-.129-.174,1.848,1.848,0,0,0-.145-.16c-.05-.051-.1-.1-.16-.146s-.114-.088-.174-.127a2.109,2.109,0,0,0-.184-.11c-.063-.034-.129-.064-.195-.092a1.945,1.945,0,0,0-.2-.072,1.924,1.924,0,0,0-.422-.085,2.252,2.252,0,0,0-.644.031,2.08,2.08,0,0,0-.209.054,1.923,1.923,0,0,0-.2.072c-.066.028-.132.059-.195.092s-.124.07-.185.11a2.139,2.139,0,0,0-.173.127c-.057.047-.11.1-.161.146a1.874,1.874,0,0,0-.145.16,2.124,2.124,0,0,0-.127.174,2.091,2.091,0,0,0-.111.185,1.967,1.967,0,0,0-.091.193,2.153,2.153,0,0,0-.073.2c-.02.067-.038.138-.053.208a2.092,2.092,0,0,0-.032.214c-.007.072-.01.144-.01.215s0,.145.01.217a2.126,2.126,0,0,0,.032.212c.015.07.032.141.053.209a2.128,2.128,0,0,0,.073.2,1.989,1.989,0,0,0,.091.195c.034.063.072.124.111.185a2.1,2.1,0,0,0,.127.173,2.15,2.15,0,0,0,.145.161c.051.05.1.1.161.145a1.875,1.875,0,0,0,.173.127c.06.04.122.078.185.111a2.426,2.426,0,0,0,.4.164c.069.021.139.038.209.053a2.093,2.093,0,0,0,.429.042,2.209,2.209,0,0,0,1.552-.643,2.377,2.377,0,0,0,.274-.334q.059-.09.11-.185c.034-.063.064-.129.092-.195a2.037,2.037,0,0,0,.072-.2,1.754,1.754,0,0,0,.053-.209,2.082,2.082,0,0,0,.032-.212,2.106,2.106,0,0,0,.011-.217Zm7.322,0a2.2,2.2,0,0,0-2.2-2.2h0a2.2,2.2,0,1,0,2.2,2.2Z"
      transform="translate(-8.001 -51.138)"
      fill="#0097fa"
    />
  </svg>
);

export const AudienceIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g id="Group_334" data-name="Group 334" transform="translate(-65 -1744)">
      <circle
        id="Ellipse_59"
        data-name="Ellipse 59"
        cx="16"
        cy="16"
        r="16"
        transform="translate(65 1744)"
        fill="#0097fa"
      />
      <g id="camera" transform="translate(72.465 1750)">
        <g
          id="Group_318"
          data-name="Group 318"
          transform="translate(12.202 6.868)"
        >
          <g id="Group_317" data-name="Group 317">
            <path
              id="Path_92"
              data-name="Path 92"
              d="M366.333,206a.333.333,0,1,0,.333.333A.334.334,0,0,0,366.333,206Z"
              transform="translate(-366 -206)"
              fill="#fff"
            />
          </g>
        </g>
        <g id="Group_320" data-name="Group 320" transform="translate(0 3.334)">
          <g id="Group_319" data-name="Group 319">
            <path
              id="Path_93"
              data-name="Path 93"
              d="M15.736,102.2H12.118l-.444-1.505,0-.011a1,1,0,0,0-.949-.684H6.349a1,1,0,0,0-.949.684l0,.011L4.952,102.2H4.2v-.333a1,1,0,0,0-1-1H2.334a1,1,0,0,0-1,1v.333A1.335,1.335,0,0,0,0,103.534V112.4a1.335,1.335,0,0,0,1.334,1.334h14.4A1.335,1.335,0,0,0,17.07,112.4v-8.868A1.335,1.335,0,0,0,15.736,102.2Zm-9.7-1.31a.333.333,0,0,1,.315-.224h4.373a.333.333,0,0,1,.315.224l.387,1.31H5.647ZM2,101.867a.334.334,0,0,1,.333-.333H3.2a.334.334,0,0,1,.333.333v.333H2ZM.667,105.531H4.883a4.34,4.34,0,0,0,.524,5.338H.667Zm7.868-1.33a3.667,3.667,0,1,1-3.667,3.667A3.669,3.669,0,0,1,8.535,104.2Zm7.868,8.2a.668.668,0,0,1-.667.667H1.334a.668.668,0,0,1-.667-.667v-.867H6.226a4.331,4.331,0,0,0,4.618,0H16.4Zm0-1.534h-4.74a4.335,4.335,0,0,0,.525-5.334H16.4Zm0-6H11.661a4.332,4.332,0,0,0-6.253,0H.667v-1.334a.668.668,0,0,1,.667-.667h14.4a.668.668,0,0,1,.667.667Z"
              transform="translate(0 -100)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_322"
          data-name="Group 322"
          transform="translate(13.536 6.868)"
        >
          <g id="Group_321" data-name="Group 321">
            <path
              id="Path_94"
              data-name="Path 94"
              d="M407.867,206h-1.534a.333.333,0,0,0,0,.667h1.534a.333.333,0,0,0,0-.667Z"
              transform="translate(-406 -206)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_324"
          data-name="Group 324"
          transform="translate(1.334 6.868)"
        >
          <g id="Group_323" data-name="Group 323">
            <path
              id="Path_95"
              data-name="Path 95"
              d="M41,206h-.667a.333.333,0,0,0,0,.667H41A.333.333,0,0,0,41,206Z"
              transform="translate(-40 -206)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_326"
          data-name="Group 326"
          transform="translate(5.868 9.202)"
        >
          <g id="Group_325" data-name="Group 325">
            <path
              id="Path_96"
              data-name="Path 96"
              d="M179.834,276a1.417,1.417,0,0,0-1.167.61A1.417,1.417,0,0,0,177.5,276a1.529,1.529,0,0,0-1.5,1.586c0,.951.735,1.565,1.848,2.493.192.161.391.327.6.508a.333.333,0,0,0,.434,0c.211-.181.41-.347.6-.507,1-.834,1.848-1.505,1.848-2.494A1.529,1.529,0,0,0,179.834,276Zm-.775,3.568-.391.328-.392-.329c-1-.837-1.608-1.342-1.608-1.981a.86.86,0,0,1,.834-.919c.619,0,.837.727.846.757a.333.333,0,0,0,.642,0c0-.008.219-.757.846-.757a.86.86,0,0,1,.834.919C180.668,278.237,180.014,278.771,179.059,279.568Z"
              transform="translate(-176 -276)"
              fill="#fff"
            />
          </g>
        </g>
        <g id="Group_328" data-name="Group 328" transform="translate(8.202)">
          <g id="Group_327" data-name="Group 327">
            <path
              id="Path_97"
              data-name="Path 97"
              d="M246.333,0A.333.333,0,0,0,246,.333V1.667a.333.333,0,1,0,.667,0V.333A.333.333,0,0,0,246.333,0Z"
              transform="translate(-246)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_330"
          data-name="Group 330"
          transform="translate(4.568 1.034)"
        >
          <g id="Group_329" data-name="Group 329">
            <path
              id="Path_98"
              data-name="Path 98"
              d="M138.521,32.05l-.943-.943a.333.333,0,0,0-.472.472l.943.943a.333.333,0,0,0,.472-.472Z"
              transform="translate(-137.009 -31.009)"
              fill="#fff"
            />
          </g>
        </g>
        <g
          id="Group_332"
          data-name="Group 332"
          transform="translate(10.893 1.034)"
        >
          <g id="Group_331" data-name="Group 331">
            <path
              id="Path_99"
              data-name="Path 99"
              d="M328.222,31.107a.333.333,0,0,0-.472,0l-.943.943a.333.333,0,0,0,.472.472l.943-.943A.333.333,0,0,0,328.222,31.107Z"
              transform="translate(-326.71 -31.009)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const EngageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="29"
    height="30"
    viewBox="0 0 29 30"
  >
    <defs>
      <clipPath id="clip-path">
        <path
          id="path717"
          d="M0-682.665H16.962V-665.7H0Z"
          transform="translate(0 682.665)"
          fill="#fff"
        />
      </clipPath>
    </defs>
    <g id="Group_334" data-name="Group 334" transform="translate(-0.127)">
      <ellipse
        id="Ellipse_59"
        data-name="Ellipse 59"
        cx="14.5"
        cy="15"
        rx="14.5"
        ry="15"
        transform="translate(0.127)"
        fill="#0097fa"
      />
      <g id="g711" transform="translate(6.332 6.519)">
        <g id="g713" transform="translate(0 0)">
          <g id="g715">
            <g id="g721" transform="translate(0.013 6.848)">
              <path
                id="path723"
                d="M-426.129-135.78a5.9,5.9,0,0,1-4.2-1.739,5.971,5.971,0,0,1-.1-8.3.248.248,0,0,1,.351-.008.248.248,0,0,1,.008.351,5.471,5.471,0,0,0,.089,7.6,5.4,5.4,0,0,0,3.847,1.594,5.405,5.405,0,0,0,3.847-1.594l2.906-2.906a.418.418,0,0,0,.123-.3.418.418,0,0,0-.123-.3l-.947-.946a.418.418,0,0,0-.3-.123.418.418,0,0,0-.3.123l-.225.225a.248.248,0,0,1-.351,0,.248.248,0,0,1,0-.351l.225-.225a.912.912,0,0,1,.649-.269.912.912,0,0,1,.649.269l.946.946a.912.912,0,0,1,.269.649.912.912,0,0,1-.269.649l-2.906,2.906A5.9,5.9,0,0,1-426.129-135.78Z"
                transform="translate(432.053 145.893)"
                fill="#fff"
              />
            </g>
            <g id="g725" transform="translate(2.392 3.651)">
              <path
                id="path727"
                d="M-6.466-95.041a3.229,3.229,0,0,1-2.27-.921,3.238,3.238,0,0,1-.976-2.313,3.236,3.236,0,0,1,.953-2.321l2.906-2.906a.418.418,0,0,0,.123-.3.418.418,0,0,0-.123-.3l-.946-.946a.418.418,0,0,0-.3-.123.418.418,0,0,0-.3.123l-2.181,2.181a.248.248,0,0,1-.351,0,.248.248,0,0,1,0-.351l2.181-2.181a.912.912,0,0,1,.649-.269.912.912,0,0,1,.649.269l.946.946a.912.912,0,0,1,.269.649.912.912,0,0,1-.269.649l-2.906,2.906a2.743,2.743,0,0,0-.808,1.967,2.744,2.744,0,0,0,.827,1.96,2.791,2.791,0,0,0,3.916-.046L-2.639-98.2a.248.248,0,0,1,.351,0,.248.248,0,0,1,0,.351l-1.834,1.834A3.309,3.309,0,0,1-6.466-95.041Z"
                transform="translate(10 105.663)"
                fill="#fff"
              />
            </g>
            <g id="g729" transform="translate(8.974 11.751)">
              <path
                id="path731"
                d="M-7.858-7.61a.248.248,0,0,1-.176-.073L-9.927-9.576a.248.248,0,0,1,0-.351.248.248,0,0,1,.351,0l1.893,1.893a.248.248,0,0,1,0,.351A.248.248,0,0,1-7.858-7.61Z"
                transform="translate(10 10)"
                fill="#fff"
              />
            </g>
            <g id="g733" transform="translate(2.821 5.598)">
              <path
                id="path735"
                d="M-7.858-7.61a.248.248,0,0,1-.176-.073L-9.927-9.576a.248.248,0,0,1,0-.351.248.248,0,0,1,.351,0l1.893,1.893a.248.248,0,0,1,0,.351A.248.248,0,0,1-7.858-7.61Z"
                transform="translate(10 10)"
                fill="#fff"
              />
            </g>
            <g id="g737" transform="translate(8.534 0)">
              <path
                id="path739"
                d="M-94.88-53.1a1.321,1.321,0,0,1,1.319,1.319,1.321,1.321,0,0,1-1.319,1.319A1.321,1.321,0,0,1-96.2-51.781,1.321,1.321,0,0,1-94.88-53.1Zm0,2.142a.823.823,0,0,0,.822-.822.823.823,0,0,0-.822-.822.823.823,0,0,0-.822.822A.823.823,0,0,0-94.88-50.958Z"
                transform="translate(96.2 53.1)"
                fill="#fff"
              />
            </g>
            <g id="g741" transform="translate(7.764 2.142)">
              <path
                id="path743"
                d="M-141.093-80.428H-144.1a.584.584,0,0,1-.583-.583v-.4a1.321,1.321,0,0,1,1.319-1.319h1.539a1.321,1.321,0,0,1,1.319,1.319v.4A.584.584,0,0,1-141.093-80.428Zm-2.276-1.807a.823.823,0,0,0-.822.822v.4a.086.086,0,0,0,.086.086h3.012a.086.086,0,0,0,.086-.086v-.4a.823.823,0,0,0-.822-.822Z"
                transform="translate(144.688 82.732)"
                fill="#fff"
              />
            </g>
            <g id="g745" transform="translate(13.553 5.288)">
              <path
                id="path747"
                d="M-94.88-53.1a1.321,1.321,0,0,1,1.319,1.319,1.321,1.321,0,0,1-1.319,1.319A1.321,1.321,0,0,1-96.2-51.781,1.321,1.321,0,0,1-94.88-53.1Zm0,2.142a.823.823,0,0,0,.822-.822.823.823,0,0,0-.822-.822.823.823,0,0,0-.822.822A.823.823,0,0,0-94.88-50.958Z"
                transform="translate(96.2 53.1)"
                fill="#fff"
              />
            </g>
            <g id="g749" transform="translate(12.784 7.429)">
              <path
                id="path751"
                d="M-141.093-80.428H-144.1a.584.584,0,0,1-.583-.583v-.4a1.321,1.321,0,0,1,1.319-1.319h1.539a1.321,1.321,0,0,1,1.319,1.319v.4A.584.584,0,0,1-141.093-80.428Zm-2.276-1.807a.823.823,0,0,0-.822.822v.4a.086.086,0,0,0,.086.086h3.012a.086.086,0,0,0,.086-.086v-.4a.823.823,0,0,0-.822-.822Z"
                transform="translate(144.688 82.732)"
                fill="#fff"
              />
            </g>
            <g id="g753" transform="translate(13.553 0)">
              <path
                id="path755"
                d="M-94.88-53.1a1.321,1.321,0,0,1,1.319,1.319,1.321,1.321,0,0,1-1.319,1.319A1.321,1.321,0,0,1-96.2-51.781,1.321,1.321,0,0,1-94.88-53.1Zm0,2.142a.823.823,0,0,0,.822-.822.823.823,0,0,0-.822-.822.823.823,0,0,0-.822.822A.823.823,0,0,0-94.88-50.958Z"
                transform="translate(96.2 53.1)"
                fill="#fff"
              />
            </g>
            <g id="g757" transform="translate(12.784 2.142)">
              <path
                id="path759"
                d="M-103.818-80.429h-.926a.248.248,0,0,1-.248-.248.248.248,0,0,1,.248-.248h.926a.086.086,0,0,0,.086-.086v-.4a.824.824,0,0,0-.823-.823h-1.539a.824.824,0,0,0-.823.823v.4a.086.086,0,0,0,.086.086h.926a.248.248,0,0,1,.248.248.248.248,0,0,1-.248.248h-.926a.584.584,0,0,1-.583-.583v-.4a1.321,1.321,0,0,1,1.32-1.32h1.539a1.321,1.321,0,0,1,1.32,1.32v.4A.584.584,0,0,1-103.818-80.429Z"
                transform="translate(107.413 82.733)"
                fill="#fff"
              />
            </g>
            <g id="g761" transform="translate(7.097 6.528)">
              <path
                id="path763"
                d="M-89.846-11.589h0a.383.383,0,0,1,.383.383v2.383a.383.383,0,0,1-.383.383.379.379,0,0,1-.269-.112l-.353-.353-1.11,1.11a.379.379,0,0,1-.269.112.383.383,0,0,1-.383-.383v-2.383a.383.383,0,0,1,.383-.383.379.379,0,0,1,.269.112l.353.353,1.11-1.11A.379.379,0,0,1-89.846-11.589ZM-89.96-9.1v-1.829L-91-9.886a.313.313,0,0,1-.223.092.313.313,0,0,1-.223-.092l-.286-.286v1.829l1.043-1.043a.313.313,0,0,1,.223-.092.313.313,0,0,1,.223.092Z"
                transform="translate(92.232 11.589)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const FollowersIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="30"
    viewBox="0 0 29 30"
  >
    <g id="Group_334" data-name="Group 334" transform="translate(-0.127)">
      <ellipse
        id="Ellipse_59"
        data-name="Ellipse 59"
        cx="14.5"
        cy="15"
        rx="14.5"
        ry="15"
        transform="translate(0.127)"
        fill="#0097fa"
      />
      <g id="user" transform="translate(2.25 3.123)">
        <path
          id="Path_100"
          data-name="Path 100"
          d="M14.1,10.366A2.731,2.731,0,1,0,16.828,13.1,2.731,2.731,0,0,0,14.1,10.366ZM10,13.1a4.1,4.1,0,1,1,4.1,4.1A4.1,4.1,0,0,1,10,13.1Z"
          transform="translate(-2.22 -1.903)"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          id="Path_101"
          data-name="Path 101"
          d="M13.138,20.365a5.463,5.463,0,0,0-4.871,2.99.683.683,0,1,1-1.218-.618,6.828,6.828,0,0,1,12.177,0,.683.683,0,1,1-1.218.618,5.463,5.463,0,0,0-4.871-2.99Z"
          transform="translate(-1.261 -5.074)"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          id="Path_102"
          data-name="Path 102"
          d="M21,6.683A.683.683,0,0,1,21.683,6h4.1a.683.683,0,1,1,0,1.366h-4.1A.683.683,0,0,1,21,6.683Z"
          transform="translate(-5.709 -0.951)"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          id="Path_103"
          data-name="Path 103"
          d="M24.683,3a.683.683,0,0,1,.683.683v4.1A.683.683,0,1,1,24,7.78v-4.1A.683.683,0,0,1,24.683,3Z"
          transform="translate(-6.66 0)"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          id="Path_104"
          data-name="Path 104"
          d="M13.057,4.459a7.279,7.279,0,0,0-1.178-.094h0a7.511,7.511,0,1,0,7.511,7.511h0a7.284,7.284,0,0,0-.094-1.178.683.683,0,1,1,1.348-.218,8.646,8.646,0,0,1,.111,1.4A8.877,8.877,0,1,1,11.876,3m8.878,8.878h0Z"
          transform="translate(0 0)"
          fill="#fff"
          fillRule="evenodd"
        />
      </g>
    </g>
  </svg>
);
